export enum InteractionPlaceComponentNames {
  MarketplaceSearchBar = 'MarketplaceSearchBar',
  MarketplaceProductCard = 'MarketplaceProductCard',
  MarketplaceCategoryContent = 'MarketplaceCategoryContent',
}

export default interface InteractionPlace {
  componentName: InteractionPlaceComponentNames
  search?: {
    queryKey?: string
    queryText: string
  }
}
